import React, { useState, useEffect } from 'react';
import { Modal, Form, Table, Button, Popover } from 'antd';
import { http } from 'libs';
import store from './store';
import { observer } from 'mobx-react';
import styles from './index.module.less'

export default observer(function IFormLog() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setData(store.expressList)
  }, [])


  function onDownload(info) {
    console.log(store.record, info)
    http.get(`/api/stock/pdf/?id=${store.record.id}&express_id=${info.id}`)
      .then(
        res => window.open(res)
      )
  }


  const columns = [
    {
      title: '物流单号',
      width: 120,
      dataIndex: 'no'
    }, {
      title: '物流公司',
      width: 200,
      dataIndex: 'company'
    }, 
    // {
    //   title: 'WMS附件',
    //   width: 100,
    //   render: info => <Button disabled={!info.url} href={info.url} type='link' style={{ fontSize: '12px' }}>附件下载</Button>
    // }, 
    {
      title: '物流信息',
      render: info => info.no ?
        <span>
          <Popover
            placement="right"
            title={<span style={{ fontSize: '0.0625rem' }}>物流详情</span>}
            trigger="click"
            content={info.detail&&JSON.parse(info.detail).map((item, index) => (
              <p style={{ fontSize: '0.0625rem' }}>{item.time} {item.context}</p>
            ))}>
            <Button type="link" style={{ fontSize: '0.0625rem' }} >查看详情</Button>
          </Popover>
          <Button type='link' onClick={() => onDownload(info)} style={{ fontSize: '0.0625rem' }}>物流pdf下载</Button></span>

        : <Button type="link" disabled style={{ fontSize: '0.0625rem' }} >自配送</Button>

    },
    // {
    //   title: '供应商直发附件',
    //   render: info => info.attachment &&
    //     <Button 
    //       type='link'
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       href={info.attachment}
    //       style={{ fontSize: '0.0625rem' }}>下载</Button>
    // }
  ]


  return (
    <Modal
      visible
      width={'500px'}
      maskClosable={false}
      title={'查看物流'}
      onCancel={()=>{store.formLogVisible = false}}
      footer={[<Button type='primary' onClick={()=>{store.formLogVisible = false}}>确定</Button>]}>
      <Form>
        <Form.Item>
          <Table
            loading={loading}
            rowKey='id'
            pagination={false}
            className={styles.Table}
            size='small'
            columns={columns}
            dataSource={data}
          >
          </Table>
        </Form.Item>
      </Form>
    </Modal>
  )
})